import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const getListDetailsCharts = (query) => http.get(`${api}/compras-catalogo/list-details-charts`, { params: { ...query } })

export {
  getListDetailsCharts
}
